import { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DashboardContext from "../../../Context";
import InputControl from "../../../components/inputs/InputControl";
import InputControlAsyncMultiBulk from "../../../components/inputs/InputControlAsyncMultiBulk";
import Axios from "axios"
import InputControlAsync from "../../../components/inputs/InputControlAsync";

export default function FavoritelistCustomer() {

    const { handelFromTabel, urldashboard, sideBardata, authentication, showEditOrder, handelEditOrder, handeldmicro, showformmicro, setOnSearchLoading, setOffSearchLoding, searchLoading } = useContext(DashboardContext)

    const [arryactions, setArryactions] = useState([]);

    const [isShowForm, setIsShowForm] = useState(false);

    const [userId, setUserId] = useState(0)

    const [workerIds, setWorkerIds] = useState([])

    const [dataFrom, setDataFrom] = useState({ userId: JSON.parse(sessionStorage.getItem('customerid')) })


    useEffect(() => {
        handelFromTabel({ userId: JSON.parse(sessionStorage.getItem('customerid')) })

        if (sideBardata) {
            sideBardata.map(item => {
                item.controllers.filter(find => {
                    if (`/${find.controller}` === '/Order') {
                        setArryactions(find.actions)
                        return find
                    }
                })
            })
        }
        return () => {

        };
    }, []);

    const fetchFavoritelistFromAddress = async (addressId) => {

        try {
            const res = await Axios.get(`${urldashboard}/karlineCustomerProfile/getFavoriteListWorkers/${dataFrom.userId}/${addressId}`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })
            const data = await res.data.data

            

            setWorkerIds(data)

            // setDataFech(data)
            // handelworkername(data.fullName)

        } catch (error) {
            //handelerrors(error)
        }
    }

    const handelValue = (name, value) => {

        switch (name) {
            case "addressId":
                fetchFavoritelistFromAddress(value)
                setWorkerIds([])
                setDataFrom({ ...dataFrom, addressId: value })
                break;

            case "favoriteListWorkerIds":

                if (value.length === 0) {
                    setWorkerIds([])
                }

                setDataFrom({ ...dataFrom, favoriteListWorkerIds: value })
                break;
            default:
                break;
        }
    }

    const handelSubmit = async (event) => {

        event.preventDefault()
        setOnSearchLoading()

        var dataForm = {
            favoriteListWorkerIds: dataFrom.favoriteListWorkerIds !== undefined ? dataFrom.favoriteListWorkerIds : workerIds.map(x => x.value),
            addressId: dataFrom.addressId,
            userId: dataFrom.userId
        }

        try {
            const res = await Axios.post(`${urldashboard}/karlineCustomerProfile/SetFavoriteListWorkers`, JSON.stringify(dataForm), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })

            setOffSearchLoding();

        } catch (error) {
            //handelerrors(error)
        }

        handelFromTabel(dataFrom)
    }

    return (
        <>
            <Form>
                <Form.Row>

                    <Col lg='6' md='3' sm='12' xs='12' >
                        <InputControl url={`/userManagement/addressdropdown/${JSON.parse(sessionStorage.getItem('customerid'))}`} label='آدرس های مشتری' name='addressId' handelValue={handelValue} defaultValue={0} />
                    </Col>

                    <Col>
                        <InputControlAsyncMultiBulk url='/worker/bulksearch' label='لیست نیروها' name='favoriteListWorkerIds' isDefaultValue={true} idSelect={workerIds} handelValue={handelValue} defaultValue={workerIds} />
                    </Col>

                </Form.Row>
                <Form.Row>
                    <Col className='d-flex'>

                        <Button onClick={handelSubmit} variant='success' >

                            {
                                searchLoading ?
                                    <i className="fa fa-spinner fa-pulse fa-fw"></i>

                                    : "ذخیره"
                            }

                        </Button>
                    </Col>
                </Form.Row>
            </Form>
        </>
    )
}
